import React from 'react';

// Styles & Assets
import styles from './DialogDuplicateDelete.module.css';

// Components
import CancelConfirmButtons from "../../UI/CancelConfirmButtons/CancelConfirmButtons";

// Interfaces
interface Props {
    onCancel: () => void
    onConfirm: () => void
    title: string
}

const DialogDuplicateDelete: React.FC<Props> = ({ onCancel, onConfirm, title }) => {

    return (
        <div className='dialog'>
            <h1 className={`${styles.title} dialogTitle`}>{title}</h1>
            <CancelConfirmButtons
                onCancel={onCancel}
                onConfirm={onConfirm}
            />
        </div>
    );
};

export default DialogDuplicateDelete;
